import nl from './nl.js';
import en from './en.js';
import fr from './fr.js';

const dictionaries = { nl, en, fr };

export default dictionaries;
